import { labelsConstants } from '@constants/labels';

const initialState = {
    data: [],
};

export function labels(state = initialState, action) {
    switch (action.type) {
        case labelsConstants.LABELS_SUCCESS:
            return { ...state, data: action.payload };
        case labelsConstants.LABELS_ERROR:
        default:
            return state;
    }
}
